export default __webpack_public_path__ + "static/media/Nadeen.d443362f.jpg";